<script setup>

import Chart from 'chart.js/auto';
import {onMounted} from 'vue'

const props = defineProps({

  chartId: {type: String},
  config: {type: Object},
  height: {type: String, default: '320px'},
  width: {type: String, default: '320px'},
  topMargin: {type: String, default: '-40px'},
  css: {type: String, default: ''},

})
// Will need to use chart.update() to refresh data source
let chart = null;

onMounted(() => {

  chart = new Chart(document.getElementById(props.chartId), props.config);

  // getChartType();

})

function getChartType() {

  if(props.css) return props.css;

  return props.config.type;
}

</script>

<template>
  <div :class="'cmp-chart-' + getChartType()">
    <canvas :id="props.chartId"></canvas>
  </div>
</template>

<style scoped>

.cmp-chart-bar {
  width: 500px;
  margin-top: 20px;
  height: max-content;
}

.cmp-chart-bar-small {
  width: 360px;
  height: 200px;
  /*margin-top: 20px;*/
  /*height: max-content;*/
}

.cmp-chart-doughnut {
  width: 320px;
  height: 320px;
  margin-top: -40px;
}

.cmp-chart-pie {
  width: v-bind(width);
  height: v-bind(height);
  margin-top: v-bind(topMargin);
}

.cmp-chart-line {
  width: 460px;
  height: max-content;

}
</style>
